import { put, takeLatest } from 'redux-saga/effects';
import config from 'utils/config';

import {
  downloadCourseTemplateSuccess,
  downloadCourseTemplateFailure,
} from '../actions';
import { CoursesActionTypes } from '../types';
import { getLocalAccessToken } from 'utils/helpers';

const { API_BASE_URL } = config || {};

function* downloadCourseTemplate() {
  const token = getLocalAccessToken()
  try {
    const response = yield fetch(`${API_BASE_URL}/course-template`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const blob = yield response.blob();
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'course_template.xlsx');
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    yield put(downloadCourseTemplateSuccess());
  } catch (err) {
    yield put(downloadCourseTemplateFailure());
  }
}

export function* onDownloadCourseTemplate() {
  yield takeLatest(
    CoursesActionTypes.DOWNLOAD_COURSE_TEMPLATE,
    downloadCourseTemplate
  );
}
